export default "/images/0752876fee4bc04d2e1e166c40240f96.avif";